import { render } from "./TermsView.vue?vue&type=template&id=1fa25a7f"
import script from "./TermsView.vue?vue&type=script&lang=js"
export * from "./TermsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__